/* eslint-disable react/jsx-key */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useEffect, useContext, useState, useRef, useMemo } from 'react'
import { Button, Input, Empty, message, DatePicker } from 'antd'
import { UnitSelection, getApiTargetInfo, ExportComponent } from 'core'
import { connect } from 'react-redux'
import {
  rowHeaderRender,
  hasAccesPermits,
  exportDataComponent,
  isValidYearRange,
} from 'core/utils'
import {
  CriteriaRow,
  Title,
  Content,
  FullHeightSizer,
  Filler,
} from 'core/screen-util'
import { strCol, numCol, intCol } from '@integec/grid-tools/lib/cols'
import {
  modifierCol,
  modifiedDateCol,
  utilityHeader,
  unitHeader,
  utilityReqHeader,
} from 'core/HeaderColTypeProps'

import {
  UnitSelectionContext,
  DatePickerContext,
  SpinContext,
  ErrorContext,
} from 'context'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getUtilityUnitsMap,
  getUnits,
  getPermitActions,
  getEnvConfig,
  isAdminType,
  getValidYearRange,
} from 'core/selectors'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
// import { loadCharTypesGrid } from './utils'
import { getGrossNoGross, getCard95, lockCard95Data } from 'api/pgads'
import Grid, {
  virtualizedGridRenderer,
  defaultVirtualizedCellRender,
} from '@integec/grid-tools'
import Card95EditDialog from './component/card95/Card95EditPromptAntd'
import CardsErrorDialog from './CardErrorDialogAntd'

import * as ScreenPermissions from 'core/EventActions'

import { loadCharTypes, NVEnergyloadCharTypes } from '../admin/component/unit'
import { getClientInfo } from '../core/selectors'
import { NVENERGY } from '../client'
import { loadCharTypesCard95, NEVADAloadCharTypes } from './utils'

const title = 'Performance Data'

export const LockCheckFunc = (lockData, data) => {
  const dataYear = '' + data.year
  const dataMonth = data.month
  const dataUnitId = data.unit

  return lockData.find(
    ({ unitId, year, month }) =>
      unitId === dataUnitId &&
      year === dataYear &&
      (month === '' + dataMonth || month === '0' + '' + dataMonth)
  )
}

const Card95Antd = ({
  actionPermits,
  envConfig,
  apiTargetInfo,
  utilityNameMap,
  unitNameMap,
  utilityUnitMap,
  CLIENT,
  ...props
}) => {
  const { spinning, setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)

  const [fuzzyFilter, setFuzzyFilter] = useState(null)
  // const [err, setError] = useState(null)
  const [data, setData] = useState([])
  // const  [editInfo, setEditInfo] = useState(freeEditEngine.generateInitialEditInfo())
  const [selectedRows, setRowsSelected] = useState([])
  const [showEditDialog, setShowEditDialog] = useState(false)
  const [mode, setMode] = useState()
  const [grossNoGross, setGrossNoGross] = useState('NO-GROSS')
  const [dataErrors, setDataErrors] = useState(null)
  const { selectedUnits, setVisibleUnitSelection } = useContext(
    UnitSelectionContext
  )

  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )

  useEffect(() => {
    setRowsSelected([])
    setData(null)
  }, [selectedDateRangePicker])

  useEffect(
    _ => {
      getGrossNoGross(apiTargetInfo).fork(setError, grossNoGross => {
        setGrossNoGross(
          grossNoGross === '0' || grossNoGross === 0 ? 'NO-GROSS' : 'GROSS'
        )
      })

      /* getUtilityUnitMap(apiTargetInfo).fork(this.setError, utilityUnitMap => {
      return this.setState({ utilityUnitMap })
    }) */
    },
    [apiTargetInfo, setError]
  )

  const [lockData, setLockData] = useState([])

  useEffect(
    _ => {
      if (selectedUnits.length <= 0) return

      const isValid = isValidYearRange(
        props.validYearRange,
        selectedDateRangePicker[0],
        selectedDateRangePicker[1]
      )
      if (!isValid) return

      lockCard95Data(apiTargetInfo)({
        year: selectedDateRangePicker[0].format('YYYY'),
        month: selectedDateRangePicker[0].format('MM'),
        units: selectedUnits.map(u => u.unitId),
        endYear: selectedDateRangePicker[1].format('YYYY'),
        endMonth: selectedDateRangePicker[1].format('MM'),
      }).fork(curError => {
        // if (isDifferentErrorValidate(curError, error))
        setError(curError)
      }, setLockData)
    },
    [
      apiTargetInfo,
      selectedUnits,
      setError,
      setSelectedDateRagePicker,
      selectedDateRangePicker,
      props.validYearRange,
    ]
  )

  const cardFreezeAccess = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.CARD_FREEZE],
        matchAny: true,
      }),
    [actionPermits]
  )

  const loadCharTypesGrid =
    CLIENT === NVENERGY ? NVEnergyloadCharTypes : loadCharTypes

  const loadCharTypesGridDialog =
    CLIENT === NVENERGY ? NEVADAloadCharTypes : loadCharTypesCard95

  const headers = [
    unitHeader,
    intCol({ ident: 'year', display: 'Year', isKey: true, width: 60 }),
    intCol({ ident: 'month', display: 'Month', isKey: true, width: 50 }),
    utilityReqHeader,
    numCol({ ident: 'grossMaxCap', display: 'Gross Maximum Capacity' }),
    numCol({ ident: 'grossDepCap', display: 'Gross Dependable Capacity' }),
    numCol({ ident: 'grossActGen', display: 'Gross Actual Generation' }),
    numCol({ ident: 'netMaxCap', display: 'Net Maximun Capacity' }),
    numCol({ ident: 'netDepCap', display: 'Net Dependable Capacity' }),
    numCol({ ident: 'netActGen', display: 'Net Actual Generation' }),
    strCol({
      ident: 'loadChar',
      display: 'Load Characteristics',
      ...toSelectionColProps(loadCharTypesGrid),
      width: 150,
      // choices: loadCharTypes,
      ellipsis: true,
      alignment: 'left',
    }),
    intCol({ ident: 'attStart', display: 'Attempted Starts' }),
    intCol({ ident: 'actualStart', display: 'Actual Starts' }),
    strCol({ ident: 'loadDesc', display: 'Load Description', width: 150 }),
    numCol({ ident: 'servHour', display: 'Service Hours' }),
    numCol({ ident: 'resHour', display: 'Reserve Hours' }),
    numCol({ ident: 'pumpHour', display: 'Pump Hours' }),
    numCol({ ident: 'syncHour', display: 'Synchronous Hours' }),
    modifierCol,
    modifiedDateCol,
  ].map(e => ({ ...e, isFiltered: true, ellipsis: true }))

  const freezeHeaders = [
    unitHeader,
    intCol({ ident: 'year', display: 'Year', isKey: true, width: 60 }),
    intCol({ ident: 'month', display: 'Month', isKey: true, width: 50 }),
    strCol({
      ident: 'utility',
      display: 'Utility',
      width: 450,
      // isKey: true,
      isRequired: true,
      sortOrder: 'asc',
      ellipsis: true,
    }),
    numCol({ ident: 'grossMaxCap', display: 'Gross Maximum Capacity' }),
    numCol({ ident: 'grossDepCap', display: 'Gross Dependable Capacity' }),
    numCol({ ident: 'grossActGen', display: 'Gross Actual Generation' }),
    numCol({ ident: 'netMaxCap', display: 'Net Maximun Capacity' }),
    numCol({ ident: 'netDepCap', display: 'Net Dependable Capacity' }),
    numCol({ ident: 'netActGen', display: 'Net Actual Generation' }),
    strCol({
      ident: 'loadChar',
      display: 'Load Characteristics',
      ...toSelectionColProps(loadCharTypesGrid),
      width: 150,
      // choices: loadCharTypes,
      ellipsis: true,
      alignment: 'left',
    }),
    intCol({ ident: 'attStart', display: 'Attempted Starts' }),
    intCol({ ident: 'actualStart', display: 'Actual Starts' }),
    strCol({ ident: 'loadDesc', display: 'Load Description', width: 150 }),
    numCol({ ident: 'servHour', display: 'Service Hours' }),
    numCol({ ident: 'resHour', display: 'Reserve Hours' }),
    numCol({ ident: 'pumpHour', display: 'Pump Hours' }),
    numCol({ ident: 'syncHour', display: 'Synchronous Hours' }),
    modifierCol,
    modifiedDateCol,
  ].map(e => ({ ...e, isFiltered: true, ellipsis: true }))

  const conditionalHeader = useMemo(() => {
    return cardFreezeAccess ? freezeHeaders : headers
  }, [cardFreezeAccess, freezeHeaders, headers])

  const setRowsSelectedWithLock = rowData => {
    const data = rowData[0] || {}
    const lockStatus = LockCheckFunc(lockData, data) || {}

    setRowsSelected([{ ...data, lock: lockStatus.lock || 'U' }])
  }

  const onRetrieve = ({ selUnits = selectedUnits }) => {
    const isValid = isValidYearRange(
      props.validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
    if (!isValid) return

    if (selUnits.length <= 0) {
      message.error('Please,Select Unit')
      setVisibleUnitSelection(true)
      return
    }
    setSpinning(true)
    // setVisibleUnitSelection(false)
    getCard95(apiTargetInfo)(
      // selectedMonthYear.format('YYYY'),
      // selectedMonthYear.format('MM'),
      selectedDateRangePicker[0].format('YYYY'),
      selectedDateRangePicker[0].format('MM'),
      selUnits[0].utility,
      selUnits.map(u => u.unitId),
      selectedDateRangePicker[1].format('YYYY'),
      selectedDateRangePicker[1].format('MM')
    ).fork(setError, data => {
      setSpinning(false)
      setData(data)
      setRowsSelected([])
    })
  }

  const onInsert = _ => {
    setMode('N')
    setShowEditDialog(true)
  }

  const onView = _ => {
    if (selectedRows.length <= 0) {
      message.error('Please , Select row to view')
      return
    }
    setMode('V')
    setShowEditDialog(true)
  }

  const onUpdate = _ => {
    if (selectedRows.length <= 0) {
      message.error('Please , Select row to modify')
      return
    }
    setMode('E')
    setShowEditDialog(true)
  }

  const headerWithFormatter = conditionalHeader.map(header =>
    header.ident === 'utility'
      ? {
          ...header,
          // ...toSelectionColProps(utilityNameMap),
          dataFormatter: ({ value }) => utilityNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            utilityNameMap[rowData.utility] || rowData.utility,
        }
      : header.ident === 'unit'
      ? {
          ...header,
          // choices: [],
          dataFormatter: ({ value }) => unitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            unitNameMap[rowData.unit] || rowData.unit,
        }
      : header
  )

  const doDelete = () => {
    setMode('D')
    // setSpinning(true)
    setShowEditDialog(true)
    // deleteCard95(apiTargetInfo)(selectedRows).fork(setError, data => {
    //   if (data.length > 0) {
    //     setDataErrors(data)
    //     setSpinning(false)
    //   } else {
    //     message.info('Data deleted successfully.')
    //     setDataErrors()
    //     setSpinning(false)
    //     onRetrieve()
    //   }
    // })
  }
  const cellRenderer = props =>
    defaultVirtualizedCellRender({
      ...props,
      onDoubleClick: () => {
        // setMode('V')
        // setShowEditDialog(true)
        onView()
      },
    })

  const GridRef = useRef()

  return [
    dataErrors && (
      <CardsErrorDialog
        keys="card95errordialog"
        errors={dataErrors}
        closeErrorPrompt={setDataErrors}
        action={mode}
        visible={dataErrors !== undefined}
        setShowEditDialog={setShowEditDialog}
        retrieveData={onRetrieve}
      />
    ),
    <>
      {showEditDialog && (
        <Card95EditDialog
          isAdminType={props.isAdminType}
          retrieveData={onRetrieve}
          utilityUnitMap={utilityUnitMap}
          utilityNameMap={utilityNameMap}
          unitNameMap={unitNameMap}
          setDataErrors={setDataErrors}
          key="card95editprompt"
          mode={mode}
          targetInfo={apiTargetInfo}
          showEditDialog={showEditDialog}
          setShowEditDialog={setShowEditDialog}
          rowData={
            mode === 'N'
              ? {
                  utility:
                    selectedUnits.length === 1
                      ? selectedUnits[0].utility
                      : null,
                  unit:
                    selectedUnits.length === 1
                      ? selectedUnits[0].utility + selectedUnits[0].unit
                      : null,
                  month: parseInt(selectedDateRangePicker[0].format('MM')),
                  year: parseInt(selectedDateRangePicker[0].format('YYYY')),
                }
              : selectedRows[0]
          }
          grossNoGross={grossNoGross}
          headers={headers}
          setMode={setMode}
          setError={setError}
          setLoading={setSpinning}
          spinning={spinning}
          loadCharTypes={loadCharTypesGridDialog}
        />
      )}
      <div
        style={{
          backgroundColor: '#f0f2f5',
          marginLeft: '20px',
          marginRight: '20px',
        }}
      >
        <UnitSelection
          setData={() => setData(null)}
          accesskey="u"
          retrieveData={onRetrieve}
          // renderContent={renderUnitContentByCollapse({
          //   utilityUnitMap,
          //   utilityNameMap,
          //   unitNameMap,
          //   setSelectedUnits,
          //   selectedUnits,
          //   units,
          // })}
        />

        <CriteriaRow
          style={{
            display: 'flex',
            //   justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Title
            style={{
              marginRight: '15px',
              marginBottom: '5px',
              minWidth: '170px',
            }}
          >
            {title}
          </Title>
          <DatePicker.RangePicker
            allowClear={false}
            mode={['month', 'month']}
            // mode="decade"
            format="MMMM-YYYY"
            value={selectedDateRangePicker}
            placeholder={['Start month', 'End month']}
            // open={openPicker}
            onChange={dates => {
              setSelectedDateRagePicker(dates)
            }}
            onPanelChange={dates => {
              setSelectedDateRagePicker(dates)
            }}
          />
          <Button
            onClick={() => onRetrieve({ selectedUnits })}
            type="primary"
            icon="database"
            css={{ marginLeft: '10px' }}
          >
            Retrieve
          </Button>

          {/* {hasAccesPermits({
            authGodMode: envConfig.authGodMode,
            actionPermits,
            eventActions: [ScreenPermissions.CARD95_VIEWER],
            matchAny: true,
          }) && (
            <Button onClick={onView} icon="plus-circle" style={{ backgroundColor: '#e6f7ff' }}>
              View Data
            </Button>
          )} */}

          {hasAccesPermits({
            authGodMode: envConfig.authGodMode,
            actionPermits,
            eventActions: [ScreenPermissions.CARD95_ADMIN],
            matchAny: true,
          }) && (
            <>
              <Button
                onClick={onInsert}
                icon="plus-circle"
                style={{ backgroundColor: '#e6f7ff', marginLeft: '10px' }}
              >
                Insert
              </Button>
              <Button
                onClick={onUpdate}
                icon="edit"
                type="primary"
                disabled={selectedRows.length <= 0}
                css={{ marginLeft: '10px' }}
              >
                Update
              </Button>
              <Button
                type="danger"
                onClick={doDelete}
                disabled={selectedRows.length <= 0}
                icon="delete"
                css={{ marginLeft: '10px' }}
              >
                Delete
              </Button>
            </>
          )}
          <Filler />
          <Input.Search
            placeholder="Filter"
            value={fuzzyFilter}
            css={{ marginLeft: '10px', marginRight: '10px', flex: '0 0 200px' }}
            onChange={e => setFuzzyFilter(e.target.value)}
          />

          <ExportComponent
            getData={_ => exportDataComponent(GridRef, data, fuzzyFilter)}
            data={data}
            headers={headerWithFormatter}
            fileName={title}
            btnStyle={{ marginRight: '10px' }}
            disabled={!!(data && data.length <= 0)}
          />
        </CriteriaRow>
        <FullHeightSizer heightOffset={300}>
          {({ height, width }) =>
            data && data.length > 0 ? (
              <Content style={{ height: height - 20 }}>
                <Grid
                  ref={GridRef}
                  sortEnabled
                  data={data}
                  headers={headerWithFormatter}
                  altBy={u => u.utility}
                  altBgColor="#ebebeb"
                  // onEditInfoChange={info => editRow(info)}
                  // editInfo={editInfo}
                  render={virtualizedGridRenderer({
                    autoFixColByKey: cardFreezeAccess,
                    rowHeaderRender,
                    height: height - 60,
                    width: width - 50,
                    cellRender: cellRenderer,
                    selectionMode: 'single',
                  })}
                  fuzzyFilter={fuzzyFilter}
                  isEditable={false}
                  onSelectionChange={rows => {
                    setRowsSelectedWithLock(rows.selectedRows)
                  }}
                  selectionType="row"
                  selectionMode="single"
                  initialSortOptions={[
                    utilityHeader,
                    unitHeader,
                    { ident: 'year', sortOrder: 'asc' },
                    { ident: 'month', sortOrder: 'asc' },
                  ]}
                />
              </Content>
            ) : (
              <Content style={{ height: '200px' }}>
                <Empty
                  imageStyle={{ paddingTop: '30px' }}
                  description={
                    selectedUnits && selectedUnits.length <= 0
                      ? 'Please select units'
                      : data && data.length <= 0
                      ? 'No Data from Retrieve'
                      : 'Please click on retrieve button to retrieve data'
                  }
                />
              </Content>
            )
          }
        </FullHeightSizer>
      </div>
    </>,
  ]
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  utilityUnitMap: getUtilityUnitsMap(state),
  units: getUnits(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  isAdminType: isAdminType(state),
  validYearRange: getValidYearRange(state),
  CLIENT: getClientInfo(state),
})

export default connect(mapStateToProps)(Card95Antd)
